module.exports = __webpack_public_path__ + "assets/icon-money.fbbf30a8.svg";